export function isParticipantCancelled(participant) {
    const {
        status_flags: {cancelled},
    } = participant;

    return cancelled;
}
